import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../../../web/components-v2/Theme/theme';
import { brandPrimaryDark, gray3, gray4, titles, white } from '../../../../../../../../../web/styles/colors';

const { spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	section: {
		padding: `${spacing.md}px ${spacing.lg}px`,
	},
	description: {
		fontSize: typography.fontSizes.sm,
		color: gray3,
		marginBottom: spacing.md,
	},
	buttonGroup: {
		display: 'flex',
		gap: spacing.sm,
		marginTop: spacing.md,
	},
	locationList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		marginTop: spacing.sm,
	},
	locationCard: {
		backgroundColor: white,
		border: `1px solid ${gray4}`,
		borderRadius: common.borderRadius,
		padding: spacing.md,
	},
	locationCardHeader: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	locationCardInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	locationCardName: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		color: titles,
	},
	locationCardDetail: {
		fontSize: typography.fontSizes.xs,
		color: gray3,
	},
	configuredSection: {
		marginTop: spacing.md,
	},
	configuredLabel: {
		fontSize: typography.fontSizes.xs,
		color: gray4,
		marginBottom: spacing.xs,
	},
	configuredValue: {
		fontSize: typography.fontSizes.sm,
		color: titles,
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: spacing.lg,
	},
	checkboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		marginBottom: spacing.md,
	},
	checkboxLabel: {
		fontSize: typography.fontSizes.sm,
		color: brandPrimaryDark,
		cursor: 'pointer',
	},
});
